export const numberToLocalStringFilter = number => {
  return number.toLocaleString();
};
